import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import React from "react";
import { TaskItemTypeEnum } from "./TaskItemListAndAdd";

export interface TaskItemFormProps {
  taskItemTypeOptions: FormOption[];
  type: TaskItemTypeEnum;

  handleTaskItemTypeChange: (value: string) => void;
}

export default function TaskItemTypeForm({
  taskItemTypeOptions,
  type,

  handleTaskItemTypeChange,
}: TaskItemFormProps) {
  const inputs: ConfigInput[] = [
    {
      title: "Select Task Item Type",
      type: "select",
      onChange: handleTaskItemTypeChange,
      xs: 12,
      sm: 6,
      id: "taskItemType",
      placeholder: "Required",
      options: taskItemTypeOptions,
      value: type,
    },
  ];
  return (
    <ConfigForm title="Choose Task Item Type" inputs={inputs}></ConfigForm>
  );
}
